import { render } from "./TableSelection.vue?vue&type=template&id=0006e47a&scoped=true&ts=true"
import script from "./TableSelection.vue?vue&type=script&lang=ts"
export * from "./TableSelection.vue?vue&type=script&lang=ts"

import "../assets/scss/table-selection.scss?vue&type=style&index=0&id=0006e47a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0006e47a"]])

export default __exports__